import {
	AfterViewInit,
	ChangeDetectionStrategy,
	Component,
	ElementRef,
	HostListener,
	Input,
	OnChanges,
	OnInit,
	SimpleChanges,
	ViewChild
} from "@angular/core";
import {FormControl, FormGroup} from "@angular/forms";
import {NbPopoverDirective} from "@nebular/theme";
import {QuestionTypeTranslator} from "../../../application-reviewer/order-review/side-panel/checklist-panel/question-type-translator";
import {StandardName} from "../../../store/state/order.state";
import {Question, QuestionType} from "../../../store/state/checklist-common";
import {ApplicationReviewFormService} from "../../../application-reviewer/order-review/side-panel/checklist-panel/application-review-form.service";
import {Observable} from "rxjs";

@Component({
    selector: 'checklist-question',
    templateUrl: './checklist-question.template.html',
    styleUrls: ['./checklist-question.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ChecklistQuestionComponent implements AfterViewInit, OnChanges, OnInit {

	readonly NOTES_FOR_CLIENT_SERVICES: QuestionType = QuestionType.NOTES_FOR_CLIENT_SERVICES;
	readonly RANDOM: number = Math.random();

	@Input() question: Question;
	@Input() blockInputs: boolean = false;
	@Input() translator: QuestionTypeTranslator;
	// optional inputs
	@Input() positiveText: string = 'Yes';
	@Input() negativeText: string = 'No';
	@Input() formService: ApplicationReviewFormService;
	@Input() checklistScrolling$: Observable<any>;
	@ViewChild('commentTextArea', {static: false}) textAreaRef: ElementRef;

	@ViewChild('clientInputTextArea', {static: false}) clientInputTextArea: ElementRef;
	@ViewChild(NbPopoverDirective, {static: false}) popover: NbPopoverDirective;

	formControlsInfo: FormControlsInfo;

	ngOnInit(): void {
		this.formControlsInfo = this.getFromControlsInfo(this.question);

		this.checklistScrolling$.subscribe(() => {
			if (this.popover) {
				this.popover.hide();
			}
		})

		if (this.blockInputs) {
			this.formService.blockInputs();
		}
	}

	ngAfterViewInit(): void {
		if (this.textAreaRef) {
			this.setHeight(this.textAreaRef.nativeElement);
		}

		if (this.clientInputTextArea) {
			this.setHeight(this.clientInputTextArea.nativeElement);
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['blockInputs'] && !!this.formControlsInfo) {
			const control = this.formControlsInfo.formGroup.controls[this.formControlsInfo.formControlForComment] as FormControl;
			this.blockInputs ? control.disable() : control.enable();
		}
	}

	private getFromControlsInfo(question: Question): FormControlsInfo {
		return this.formService.getFormControlsInfo(question);
	}

	autoResizeOnScroll(event: Event) {
		const height: number = (event.target as HTMLTextAreaElement).scrollHeight;
		event.target['style'] = `height: ${height}px`;
	}

	setHeight(element: HTMLTextAreaElement) {
		setTimeout(() => {
			const height: number = element.scrollHeight;
			(element['style'] as any) = `height: ${height}px`;
		}, 100);
	}

	shouldDisableRadio(controlName: string): boolean {
		return this.formService.isControlDisabled(this.question.type, controlName);
	}
}

export interface FormControlsInfo {
	formGroup: FormGroup;
	formControlsForAnswer: Map<StandardName, string>;
	formControlForComment: string;
}
